import { Component, OnInit, forwardRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavController, NavParams, ModalController, ToastController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BuscarPessoaPage } from '../../buscar-pessoa/buscar-pessoa.page';
import { MensagemProvider } from 'src/app/services/mensagem/mensagem';
import { CommonModule } from '@angular/common';


import { ImagePipe } from 'src/app/pipes/image/image';
import { noWhitespaceValidator } from 'src/app/pipes/no-white-space-validator/no-white-space-validator';

@Component({
  selector: 'app-grupo-mensagem-add',
  templateUrl: './grupo-mensagem-add.page.html',
  styleUrls: ['./grupo-mensagem-add.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    ReactiveFormsModule
  ],
})
export class GrupoMensagemAddPage implements OnInit {
  idGrupo: any;
  validations_form: FormGroup;
  vincularPessoa: boolean = false;
  pessoa: any = {};
  isAdm: any;
  isParticipante: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public mensagemProvider: MensagemProvider,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController,
    private translate: TranslateService
  ) {
    this.idGrupo = this.navParams.get('idGrupo');
    this.isAdm = this.navParams.get('isAdm');
    this.isParticipante = this.navParams.get('isParticipante');

    this.validations_form = this.formBuilder.group({
      titulo: ['', [Validators.required, noWhitespaceValidator]],
      mensagem: ['', [Validators.required, noWhitespaceValidator]],
      idPessoa: new FormControl('', Validators.nullValidator),
    });
  }
  ngOnInit() {
  }

  validation_messages = {
    'titulo': [
      { type: 'required', message: this.translate.instant('O título deve ser informado') }
    ],
    'mensagem': [
      { type: 'required', message: this.translate.instant('A mensagem deve ser informada') }
    ]
  };

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  onSubmit(submitMensagem: { mensagem: any; titulo: any; }) {
    const mensagem: any = {};
    mensagem.aplicativo = '1'
    mensagem.conteudo = submitMensagem.mensagem;
    mensagem.idMensagemTipo = 0;
    mensagem.portal = '1';
    mensagem.titulo = submitMensagem.titulo;
    if (this.pessoa.id) {
      mensagem.entidade = 'pessoa';
      mensagem.idEntidade = this.pessoa.id;
    } else {
      mensagem.entidade = 'grupo';
      mensagem.idEntidade = this.idGrupo;
    }

    this.mensagemProvider.criarMensagem(mensagem).subscribe(async data => {
      const toast = await this.toastCtrl.create({
        message: this.translate.instant('Mensagem criada com sucesso!'),
        duration: 3000
      });

      toast.present();
      this.modalCtrl.dismiss(data);
    });
  }

  definirPermissoes() {
    if (this.isAdm) return this.abrirBuscarPessoa();
    if (this.isParticipante) return this.abrirBuscarPessoa({ participante: true });
  }

  private async abrirBuscarPessoa(extraProps: Record<string, any> = {}) {
    const componentProps = { idGrupo: this.idGrupo, ...extraProps };

    const modal = await this.modalCtrl.create({
      component: BuscarPessoaPage,
      componentProps
    });

    await modal.present();

    const pessoa = (await modal.onWillDismiss())
    if (pessoa.data) {
      this.pessoa = pessoa.data.pessoa;
    } else {
      this.vincularPessoa = false;
    } 
  }

  changeVincular(vincular: boolean) {
    this.vincularPessoa = vincular;

    if (this.vincularPessoa) {
      this.definirPermissoes();
    } else {
      this.pessoa = {};
    }
  }
}
